import React from 'react';
import { CoreAsyncButton, CoreTable } from '@amzn/dots-core-ui';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import { Device, useClient, useInfiniteGetAll } from '$/api';
import { DeviceColumnDefinitions } from '$/features/Devices';

type LabDevicesTableProps = {
  labId?: number;
};

export const LabDevicesTable = ({
  labId,
}: LabDevicesTableProps): JSX.Element => {
  const { devices } = useClient();
  const { data, allData, isLoading, hasNextPage, fetchNextPage } =
    useInfiniteGetAll(devices.resourceKey, devices.getAll, { labId });
  return (
    <Column spacing="small">
      <Heading level={3}>Devices</Heading>
      <CoreTable
        fixHeaderRows
        isLoading={isLoading && !data}
        columnDefinitions={DeviceColumnDefinitions}
        getItemId={(item: Device) => item.id}
        items={allData}
      />
      <Row alignmentHorizontal="center">
        <CoreAsyncButton
          disabled={!hasNextPage}
          type="tertiary"
          onClick={async (): Promise<void> => {
            await fetchNextPage();
          }}
        >
          Load More
        </CoreAsyncButton>
      </Row>
    </Column>
  );
};

LabDevicesTable.defaultProps = {
  labId: '',
};
